import React from "react";
import {
    Button,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Typography,
    CircularProgress,
} from "@mui/material";

export default function DeleteConfirmDialog({ open, onClose, onConfirm, taskTitle, deleting }) {
    return (
        <Dialog
            open={open}
            onClose={deleting ? undefined : onClose}
            maxWidth="xs"
            fullWidth
            PaperProps={{ sx: { borderRadius: 3 } }}
        >
            <DialogTitle sx={{ fontFamily: "Montserrat, sans-serif", fontWeight: 700 }}>
                Delete Task
            </DialogTitle>
            <DialogContent>
                <Typography variant="body2" sx={{ fontFamily: "Montserrat, sans-serif" }}>
                    Delete <strong>{taskTitle}</strong>? This cannot be undone.
                </Typography>
            </DialogContent>
            <DialogActions sx={{ px: 3, pb: 2 }}>
                <Button onClick={onClose} disabled={deleting}>
                    Cancel
                </Button>
                <Button
                    variant="contained"
                    color="error"
                    onClick={onConfirm}
                    disabled={deleting}
                    startIcon={deleting ? <CircularProgress size={16} color="inherit" /> : null}
                >
                    Delete
                </Button>
            </DialogActions>
        </Dialog>
    );
}
